/**************
 Cart
 ***************/

// open cart
async function openCart(addedProduct) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }

    // hide all sections
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartButton").classList.remove("active");
    document.querySelector("#miniCartContinue").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    cart = await getCart();

    //add drop animation class on cart
    document.querySelector('#miniCartContent').classList.add('active');

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartButton").textContent = `View Cart (${cart.item_count})`;

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartButton").classList.add("active");
    document.querySelector("#miniCartContinue").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // find recently added
    const recentlyAdded = cart.items.find(item => item.id === addedProduct.id);

    // variant HTML
    function variantHTML() {
        let HTML = "";

        // add any options to variant section on cart item
        for (let option in recentlyAdded.options_with_values) {
            // skip default
            if (recentlyAdded.options_with_values[option].value === "Default Title") continue;

            HTML += `<div class="miniCartBodyItemVariantItem">${recentlyAdded.options_with_values[option].name}: ${recentlyAdded.options_with_values[option].value}</div>`
        }

        // add any properties to variant section on cart item
        for (let key in recentlyAdded.properties) {
            // skip properties that start with _
            if (key.startsWith("_")) continue;

            // add property to HTML
            HTML += `<div class="miniCartBodyItemVariantItem">${key}: ${recentlyAdded.properties[key]}</div>`
        }

        return HTML;
    }

    // insert item
    document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
        <div class="miniCartBodyItem">
            <img class="miniCartBodyItemImage" src="${recentlyAdded.image}&width=200">
            <div class="miniCartBodyItemFlex">
                <div class="miniCartBodyItemTitle">${recentlyAdded.product_title}</div>
                <div class="miniCartBodyItemVariant">${variantHTML()}</div>
            </div>
            <div class="miniCartBodyItemQuantity">Qty: ${recentlyAdded.quantity}</div>
        </div>
    `);

}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector('#miniCartContent').classList.remove('active');
    // give time for cart to rise off screen
    setTimeout(() => {
        document.querySelector("#miniCart").close();
    }, 800)
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
